import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  search: {
    position: "relative",
    borderRadius: `${theme.shape.borderRadius}px`,
    borderColor: "black",
    backgroundColor: "white",
    width: "100%",
  },
  table: {
    cursor: "pointer",
  },
});
